import settings from './settings'

export const onDutyFree = settings.channel === 'dutyfree'
